import React from 'react';
import { CHECKOUT_URL, modules } from '../data/atlante';
export function ModulesSection() {
  return <section className="bg-ivory px-4 py-5 sm:py-7" data-id="element-94" data-mp="1nued3mybihmk">
      <div className="mx-auto max-w-5xl" data-id="element-95" data-mp="1nsl8seb6g9hq">
        <h2 className="text-center text-xl leading-tight text-navy sm:text-2xl" data-id="element-96" data-mp="1ius1tj21vbge">
          COSA È INCLUSO
        </h2>

        <div className="mt-3 grid gap-2.5 md:grid-cols-2" data-id="element-97" data-mp="1dxt7azeh52ho">
          {modules.map(module => <a key={module.num} href={CHECKOUT_URL} className="flex flex-col border border-navy/15 bg-white p-4 shadow-sm transition-colors duration-150 hover:border-gold" data-id="element-98" data-mp="2bixnq94ub6ht">
              <p className="font-display text-[11px] font-extrabold uppercase tracking-wide text-green" data-id="element-99" data-mp="21o5pr47cihmi">
                ✅ MODULO {module.num}
              </p>
              <h3 className="mt-0.5 text-[15px] leading-tight text-navy sm:text-base" data-id="element-100" data-mp="q7yuuiy2hfxy">
                {module.title}
              </h3>
              <p className="mt-1.5 text-[13px] font-medium leading-snug text-slate2" data-id="element-101" data-mp="l9xe44o45spn">
                {module.body}
              </p>
              {module.body2 && <p className="mt-1.5 text-[13px] font-medium leading-snug text-slate2" data-id="element-102" data-mp="1nt0k4vfmjna9">
                  {module.body2}
                </p>}
              <p className="mt-auto pt-2 font-display text-[13px] font-extrabold uppercase tracking-wide text-navy" data-id="element-103" data-mp="1dvvu2kinr7o6">
                {module.kicker}
              </p>
            </a>)}
        </div>
      </div>
    </section>;
}